export default __webpack_public_path__ + "static/media/body-female-slim.9c7a1edb.png";